module.exports = __webpack_public_path__ + "c064d4cc4ab9e092cd8bdd84420ff4b9.svg";